import PropTypes from 'prop-types';

function SeperatorLine(props) {
  const { marginTop, marginBottom } = props;

  return (
    <hr
      className="seperatorLine"
      style={{
        marginTop: `${marginTop}px`,
        marginBottom: `${marginBottom}px`,
      }}
    />
  );
}

SeperatorLine.propTypes = {
  marginTop: PropTypes.number,
  marginBottom: PropTypes.number,
};

export default SeperatorLine;
